export default async function loader(value) { return value };